import {FormField} from "../form-field/form-field";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";
import Sortable from "sortablejs";

export class FormFieldRepeater extends FormField{
    constructor(scope,$root){
        super(scope,$root);
    }

    updateInputValue(noEvent){
        const currentVal = this.getVal();
        let setVal = "";
        if($.isArray(currentVal) && currentVal.length>0){
            setVal = JSON.stringify(currentVal);
        }
        this.$value.val(setVal);
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    getVal(){
        const values = [];
        this.findMember("item").filter(".is-item").each(
            (index,item)=>{
                const $item = $(item);
                const itemValues = {};
                let requiredNotFilled = false;
                let allFieldsEmpty = true;
                $item.find(".js-form-field").each(
                    (index,field)=>{
                        const $field = $(field);
                        const fieldName = $field.attr("data-map-name");
                        itemValues[fieldName] = $field.formFieldVal();
                        if($field.hasClass("is-required") && itemValues[fieldName]===""){
                            requiredNotFilled = true;
                        }
                        if(itemValues[fieldName]){
                            allFieldsEmpty = false;
                        }
                    }
                );
                if(!requiredNotFilled && !allFieldsEmpty){
                    values.push(itemValues);
                }
            }
        );
        return values;
    }

    setVal(val,noEvent){
        if(val && val.indexOf("[")==0){
            val = JSON.parse(val);
        }
        this.emptyDomItems();
        if($.isArray(val)){
            val.forEach(
                (itemValues)=>{
                    this.addDomItem(itemValues);
                }
            );
        }
        this.updateInputValue(noEvent);
    }

    emptyDomItems(){
        this.findMember("item").filter(".is-item").remove();
        this.findMember("empty-label").removeClass("hide");
    }

    addDomItem(itemValues){
        const $newItem = this.$placeholderItem.clone();
        const itemCount = this.getItemCount();
        $newItem.removeClass("hide is-placeholder-item");
        $newItem.addClass("is-item");
        $newItem.find(".js-form-field").each(
            (index,item)=>{
                const $field = $(item);
                const currentFieldName = $field.data("name");
                const newName = currentFieldName+"_"+itemCount;
                $field.attr("data-name",newName);
                $field.attr("data-map-name",currentFieldName.split(".").pop());
                $field.find("[name='"+currentFieldName+"']").attr("name",newName);
                $field.find("[name='"+currentFieldName+"__rich-editor']").attr("name",newName+"__rich-editor");
                $field.find("[data-input='"+currentFieldName+"']").attr("data-input",newName);
                //change duplicate ids
                $field.find("[id]").each(
                    (index,item)=>{
                        const newId = newName+$(item).attr("id");
                        $(item).attr("id",newId);
                        $field.find("[for]").attr("for",newId);
                    }
                );
            }
        );
        $newItem.find(this.scope+"__delete-item").click(
            (ev)=>{
                ev.preventDefault();
                $newItem.remove();
                this.updateInputValue();
            }
        );

        this.findMember("item").last().after($newItem);
        GvfUiService.init($newItem);
        this.findMember("empty-label").addClass("hide");
        if(itemValues!==undefined){
            $newItem.find(".js-form-field").each(
                (index,field)=>{
                    const $field = $(field);
                    const fieldName = $field.attr("data-map-name");
                    if(itemValues[fieldName]!==undefined){
                        $field.formFieldSetVal(itemValues[fieldName],true);
                    }
                }
            );
        }
    }

    getItemCount(){
        return this.findMember("item").filter(".is-item").length;
    }

    ready(){
        super.ready();
        this.$value = this.findMember("value");
        this.$placeholderItem = this.findMember("item").filter(".is-placeholder-item");
        this.$items = this.findMember("items");

        this.findMember("add").click(
            (ev)=>{
                ev.preventDefault();
                this.addDomItem();
                this.updateInputValue();
            }
        );

        this.findMember("empty").click(
            (ev)=>{
                ev.preventDefault();
                this.emptyDomItems();
                this.updateInputValue();
            }
        );

        this.$items.on("formField:changeVal",()=>{
            this.updateInputValue();
        });

        if(this.$root.data("sortable") && this.$root.hasClass("is-editable")){
            new Sortable(
                this.$items.get(0),
                {
                    onEnd: (ev)=>{
                        const fieldValue = this.getVal();
                        if($.isArray(fieldValue)){
                            const value = fieldValue.splice(ev.oldIndex,1)[0];
                            fieldValue.splice(ev.newIndex,0,value);
                            this.$value.val(JSON.stringify(fieldValue));
                        }
                    }
                }
            );
        }

        this.setVal(this.$value.val(),true);

        if(this.$root.hasClass("is-editable") && this.$value.val()=="" && this.$root.data("show-first-item")){
            this.findMember("add").click();
        }
    }
}
